export default __webpack_public_path__ + "static/media/Path3534.182bad72.svg";